import { useState } from 'react'

import { loginRegenerateOTP } from '@/actions/authActions'
import { useAppDispatch } from '@/utils/typeHelpers'

import { Button, Text, Link, Alert, Dialog, Passcode } from '@/ui'

interface OTPLoginProps {
  email: string
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  loginError: string | undefined
  otp: string | undefined
  setOtp: (otp: string) => void
  password: string
  phoneDigits: string
  onClose: () => void
}

export const OTPLogin = ({
  email,
  onSubmit,
  loginError,
  otp,
  setOtp,
  password,
  phoneDigits,
  onClose,
}: OTPLoginProps) => {
  const [resentCode, setResentCode] = useState(false)
  const dispatch = useAppDispatch()

  const resendCode = async () => {
    const result = await loginRegenerateOTP({
      email: email.toLowerCase(),
      password,
    })(dispatch)

    if (result) {
      setOtp('')
      setResentCode(true)
    }
  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    setResentCode(false)
    onSubmit(evt)
  }

  return (
    <>
      <Dialog.Title>Enter verification code</Dialog.Title>

      <Dialog.Description>
        We sent a verification code to your number on file ending in:{' '}
        {phoneDigits}. This may take a couple of minutes to arrive.
      </Dialog.Description>

      {loginError && (
        <Alert
          variant="error"
          title="It looks like this passcode could not be verified. Please double check your passcode, or generate a new one."
        />
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Passcode value={otp || ''} handleChange={setOtp} />

        <div className="flex flex-col items-center">
          <Button variant="link" onClick={resendCode} disabled={resentCode}>
            {resentCode ? 'Verification code resent!' : 'Resend code'}
          </Button>

          <Text textAlign="center">
            Still not receiving your verification code?
          </Text>
          <Text textAlign="center">
            Reach out to{' '}
            <Link href="mailto:support@joinheard.com">
              support@joinheard.com
            </Link>
          </Text>
        </div>

        <Dialog.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button type="submit" disabled={!otp}>
            Verify
          </Button>
        </Dialog.Footer>
      </form>
    </>
  )
}
